import { createCachedSelector, path, prop } from '@cbridge-utils/redux';
import { createDefaultCachedSelectorOptions } from '@cbridge-utils/reselect';
import { nodeStoreSelector } from '../node.selector';
import { INode } from '../node.interface';

export const nodeNameByIdSelector = createCachedSelector(
  [
    path(nodeStoreSelector).list(),
    prop<{ nodeId: INode['nodeId'] }>().nodeId(),
  ],
  (nodeList, nodeId) => {
    const node = nodeList.find(node => node.nodeId === nodeId);
    return node?.name;
  },
)({
  ...createDefaultCachedSelectorOptions(),
  keySelector: prop<{ nodeId: INode['nodeId'] }>().nodeId(),
});
